import qs from 'qs';
import moment from 'moment/moment';
import PropTypes from 'prop-types';
import jwtDecode from 'jwt-decode';
import {connect} from 'react-redux';
import ReactModal from 'react-modal';
import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import DocumentTitle from 'react-document-title';
import scriptLoader from 'react-async-script-loader'

import 'magnific-popup';
import 'ie-array-find-polyfill';
import 'url-search-params-polyfill';

import 'react-datepicker/dist/react-datepicker.css';
import 'react-input-range/lib/css/index.css';

import '../../static/styles/libs.min.css';
import '../../static/styles/main.scss';
import '../../static/styles/dev2.scss';
import '../../static/styles/custom.scss';

import Footer from './Footer';
import Header from './header/Header';
import UsersAPI from '../../api/Users';
import QuoteApi from '../../api/Quote';
import MobileLine from './MobileLine';
import PromoSlider from './PromoSlider';
import PromoContent from './PromoContent';
import Registration from './Registration';
import Authorization from './Authorization';
import FilterSection from './FilterSection';
import ApiErrorModal from './ApiErrorModal';
import * as AppConst from '../../constants/App';
import ScrollToTopOnMount from './ScrollToTopOnMount';
import * as RoutePath from '../../constants/RoutePaths';
import {initApp, setGoogleApiInit} from '../../actions/Global';
import * as LocalStorageUtils from '../../utils/LocalStorage';
import {confirmEmailCode, loginFacebook, setUserInfo,changeVisibleRestorePasswordSecondStep} from '../../actions/User';
import * as LocalStorageConst from '../../constants/LocalStorage';
import {createObject, setNeedCreateObject} from '../../actions/CreatingObjectPage';
import CookieGDPR from './CookieGDPR';
import {getRedirectUri} from "../../utils/FacebookUtils";
import RestorePasswordFirstStep from "./RestorePasswordFirstStep";
import RestorePasswordSecondStep from "./RestorePasswordSecondStep";
import {store} from "./App";

const propTypes = {
    children: PropTypes.node,
    title: PropTypes.string.isRequired
};

const defaultProps = {
    showPromoSlider: false,
    showPromoContent: false,
    createObject: authorId => {
    },
    setUserInfo: accessToken => {
    },
    loginFacebook: accessToken => {
    },
    initApp: () => {
    },
    setNeedCreateObject: isNeedCreateObject => {
    }
};

class Layout extends Component {

    activateQuote(quoteKey) {
        QuoteApi.activateQuote(quoteKey).then(({data}) => {
            window.location = data;
        });
    }

    confirmEmail(confirmationEmail) {
        this.props.confirmEmailCode(confirmationEmail);
    }

    resetPassword() {
        this.props.changeVisibleRestorePasswordSecondStep(true);
    }


    componentWillMount() {
        // Необходимость для ReactModal
        ReactModal.setAppElement('body');

        // Перехват редиректа после авторизации через Facebook
        const params = qs.parse(this.props.location.search.substring(1));
        if (params.code !== undefined) {
            this.loginFacebook(params.code).then(() => {
                let key = LocalStorageUtils.get(LocalStorageConst.KEYS.PATHNAME_AFTER_AUTH);
                if (key.indexOf('/crm') == -1) {
                    this.props.history.push(key);
                } else {
                    window.location = key;
                }
            });
        }

        if (params.action === 'activateQuote') {
            this.activateQuote(params.key);
        }

        if (params.action === 'activateEmail') {
            this.confirmEmail(params.key);
        }

        if (params.action === 'resetPassword') {
            this.resetPassword();
        }

        moment.updateLocale('en', {
            week: {
                dow: 1
            }
        });

        moment.locale('ru', {
            months: [
                "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль",
                "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
            ],
            weekdaysMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
            week: {
                dow: 1
            }
        });

        moment.locale('es', {
            months: [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
                "Agosto", "Septriembre", "Octubre", "Noviembre", "Diciembre"
            ],
            weekdaysMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"],
            week: {
                dow: 1
            }
        });
    }

    componentDidMount() {
        Layout.init();
        this.setUserInfo();

        this.props.initApp();

        if (store.getState().user.currentUser.accessToken && !store.getState().user.currentUser.email) {
            window.location.href = "/crm/inbox";
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setGoogleApiInit(nextProps);
        this.createObject(nextProps);
    }

    setUserInfo() {
        const {accessToken} = this.props;
        if (accessToken !== null) {
            this.props.setUserInfo(accessToken);
        }
    }

    setGoogleApiInit(nextProps) {
        const {isScriptLoaded, isScriptLoadSucceed} = nextProps;
        if (isScriptLoaded && !this.props.isScriptLoaded) {
            if (isScriptLoadSucceed) {
                this.props.setGoogleApiInit();
            }
        }
    }

    loginFacebook(code) {
        return UsersAPI.facebookLogin(code, getRedirectUri())
            .then(({data: {token}}) => {
                this.props.loginFacebook(token);
            }).catch(() => {
                console.log("error");
            });
    }

    createObject = nextProps => {
        const {
            createObject,
            setNeedCreateObject,
            user: {
                currentUser: {
                    accessToken
                }
            },
            creatingObjectPage: {
                isNeedCreateObject
            }
        } = nextProps;

        if (isNeedCreateObject && accessToken !== null) {
            createObject(jwtDecode(accessToken).userId);
            setNeedCreateObject(false);
        }
    };

    static init() {
        const $ = window.jQuery;

        $(document).ready(function () {
            $(".reviews-toggle").on("click", function (e) {
                e.preventDefault();
                $(this).toggleClass("opened");
            });

            if ($(window).outerWidth() < 1170) {
                $(".wrapper").removeClass("search_for_map_active");
            }

            $(window).on("resize", function () {
                if ($(window).outerWidth() < 1170)
                    $(".wrapper").removeClass("search_for_map_active");
            });

            $(".sort_to span").click(function () {
                $(".sort_to ul").fadeToggle();
            });

            /*мобильное меню*/
            $(".burger").click(function () {
                $(this).toggleClass('close_mobile');
                $(".mob_nav").fadeToggle();
            });
            /*все фильтры на планшете*/
            $(".btn_clear").click(function () {
                $(this).toggleClass('btn_clear_close');
                $(".filters_block_mobile_more").fadeToggle();
            });

            $(".accordion-container").on("click .set", "a", function () {
                let a = $(this);
                if (a.hasClass('normal')) {
                    return true;
                }
                if (a.hasClass('active')) {
                    a.removeClass("active");
                    a.siblings('.set p').slideUp(200);
                    $(".set i").removeClass("icon-open").addClass("icon-default");
                } else {
                    $(".set	i").removeClass("icon-open").addClass("icon-default");
                    a.find("i").removeClass("icon-default").addClass("icon-open");
                    $(".set a").removeClass("active");
                    a.addClass("active");
                    $('.set p').slideUp(200);
                    a.siblings('.set p').slideDown(200);
                }
                return false
            });

        });
    }

    render() {
        const {children, title} = this.props;

        return (
            <DocumentTitle title={title}>
                <div
                    className={this.props.location.pathname === RoutePath.SEARCH && this.props.searchPage.isHorizontalMode ?
                        "wrapper search_for_map_active" :
                        "wrapper"}
                >
                    <ScrollToTopOnMount/>
                    <div className="promo">
                        <MobileLine/>
                        <Header/>
                        {this.props.showPromoContent && <PromoContent/>}
                        {this.props.showPromoContent && <FilterSection/>}
                        {this.props.showPromoSlider && <PromoSlider/>}
                    </div>
                    {children}
                    <Footer/>
                    <Authorization/>
                    <Registration/>
                    <ApiErrorModal/>
                    <CookieGDPR/>
                    <RestorePasswordFirstStep/>
                    <RestorePasswordSecondStep/>
                </div>
            </DocumentTitle>
        )
    }
}

Layout.propTypes = propTypes;
Layout.defaultProps = defaultProps;

const mapStateToProps = state => ({
    user: state.user,
    searchPage: state.searchPage,
    code: state.languages.currentLanguage.code,
    creatingObjectPage: state.creatingObjectPage,
    accessToken: state.user.currentUser.accessToken,
    defaultCode: state.configuration.main.defaultCode
});

const mapDispatchToProps = {
    setUserInfo,
    createObject,
    loginFacebook,
    setGoogleApiInit,
    setNeedCreateObject,
    confirmEmailCode,
    initApp,
    changeVisibleRestorePasswordSecondStep
};

export default withRouter(scriptLoader(
    [`https://maps.googleapis.com/maps/api/js?key=${AppConst.GOOGLE_API_KEY}&libraries=geometry,drawing,places`]
)(
    connect(mapStateToProps, mapDispatchToProps)(Layout)
));



// WEBPACK FOOTER //
// ./src/components/Base/Layout.js